import { useSelector } from 'react-redux';
import { selectMarketplaces } from 'redux/selectors';
import { useActions } from 'hooks/redux/useActions';
import {
  setMarketplaces,
  setMarketplacesIfEmpty,
  unsetMarketplaces,
} from 'redux/reducers/marketplaces-reducer';

export function useMarketplaces() {
  const { items: marketplaces, status: marketplacesStatus } =
    useSelector(selectMarketplaces);
  const actions = useActions({
    setMarketplaces,
    unsetMarketplaces,
    setMarketplacesIfEmpty,
  });

  return { marketplaces, marketplacesStatus, ...actions };
}
